import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Layout from "../components/layout";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import productsList from "../data/products.json";

function Home() {

    const [show, setShow] = useState(false);
    const [enquireShow, setEnquireShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleEnquireShow = () => {
        setEnquireShow(true);
        setFullName("");
        setEmail("");
        setMessage("");
        setMobileNo("");
        setErrorMessage("");
    }
    const handleEnquireClose = () => setEnquireShow(false);

    const [fullName, setFullName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [mobileNo, setMobileNo] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [message, setMessage] = React.useState("");

    const [errorMessage, setErrorMessage] = React.useState("");

    const [productName, setProductName] = React.useState("");
    const [refreshURL, setRefreshURL] = React.useState("");
    const [resetKey, setResetKey] = React.useState(0);

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Layout>
            <div>
                {width > 768 ? <div className="banner-carousel banner-carousel-1 mb-0">
                    <div className="banner-carousel-item" style={{ backgroundImage: 'url(assets/images/slider-main/bg1.jpg)' }}>
                        <div className="slider-content">
                            <div className="container h-100 text-left">
                                <div className="row align-items-center h-100">
                                    <div className="col-md-12 text-left">
                                        <h2 className="slide-title-box" data-animation-in="slideInDown">Secure's Product</h2>
                                        <h3 className="slide-sub-title" data-animation-in="slideInRight">APEX 100</h3>
                                        <h3 className="slide-title" data-animation-in="slideInLeft">High-end Precision Meter</h3>
                                        <p data-animation-in="slideInLeft" data-duration-in="1.2">
                                            <a href="#" className="slider btn btn-primary" onClick={handleEnquireShow}>Enquire Now</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-carousel-item" style={{ backgroundImage: 'url(assets/images/slider-main/bg2.jpg)' }}>
                        <div className="slider-content text-left">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-md-12">
                                        <h2 className="slide-title-box" data-animation-in="slideInDown">Secure's Product</h2>
                                        <h3 className="slide-sub-title" data-animation-in="slideInRight">APEX 150</h3>
                                        <h3 className="slide-title" data-animation-in="slideInLeft">Precision Metering Series</h3>
                                        <p data-animation-in="slideInLeft" data-duration-in="1.2">
                                            <a href="#" className="slider btn btn-primary" onClick={handleEnquireShow}>Enquire Now</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-carousel-item" style={{ backgroundImage: 'url(assets/images/slider-main/bg3.jpg)' }}>
                        <div className="slider-content text-left">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-md-12">
                                        <h2 className="slide-title-box" data-animation-in="slideInDown">Secure's Product</h2>
                                        <h3 className="slide-sub-title" data-animation-in="slideInRight">Liberty 170</h3>
                                        <h3 className="slide-title" data-animation-in="slideInLeft">Single-phase pre-payment electricity meter</h3>
                                        <p data-animation-in="slideInLeft" data-duration-in="1.2">
                                            <a href="#" className="slider btn btn-primary" onClick={handleEnquireShow}>Enquire Now</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-carousel-item" style={{ backgroundImage: 'url(assets/images/slider-main/bg4.jpg)' }}>
                        <div className="slider-content text-left">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-md-12">
                                        <h2 className="slide-title-box" data-animation-in="slideInDown">Secure's Product</h2>
                                        <h3 className="slide-sub-title" data-animation-in="slideInRight">Elite 440</h3>
                                        <h3 className="slide-title" data-animation-in="slideInLeft">Multi-line Three-phase Panel Meter</h3>
                                        <p data-animation-in="slideInLeft" data-duration-in="1.2">
                                            <a href="#" className="slider btn btn-primary" onClick={handleEnquireShow}>Enquire Now</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-carousel-item" style={{ backgroundImage: 'url(assets/images/slider-main/bg5.jpg)' }}>
                        <div className="slider-content text-left">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-md-12">
                                        <h2 className="slide-title-box" data-animation-in="slideInDown">Secure's Product</h2>
                                        <h3 className="slide-sub-title" data-animation-in="slideInRight">Elite 500</h3>
                                        <h3 className="slide-title" data-animation-in="slideInLeft">Modbus / BACnet / Profinet / IEC61850 protocol</h3>
                                        <p data-animation-in="slideInLeft" data-duration-in="1.2">
                                            <a href="#" className="slider btn btn-primary" onClick={handleEnquireShow}>Enquire Now</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null}
                {width > 768 ? <section className="call-to-action-box no-padding">
                    <div className="container">
                        <div className="action-style-box">
                            <div className="row align-items-center">
                                <div className="col-md-8 text-center text-md-left">
                                    <div className="call-to-action-text">
                                        <h3 className="action-title">Secure Meter Authorised Dealer</h3>
                                    </div>
                                </div>{/* Col end */}
                                <div className="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div className="call-to-action-btn">
                                        <a className="btn btn-dark" href="#" onClick={handleEnquireShow}>Enquire Now</a>
                                    </div>
                                </div>{/* col end */}
                            </div>{/* row end */}
                        </div>{/* Action style box */}
                    </div>{/* Container end */}
                </section> : null}
                <section id="ts-features" className="ts-features">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="ts-intro">
                                    <h2 className="into-title">About Us</h2>
                                    <h3 className="into-sub-title">Testing and measuring instruments.</h3>
                                    <p style={{ textAlign: 'justify' }}>Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research.</p>
                                </div>{/* Intro box end */}
                                <div className="gap-20" />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="ts-service-box">
                                            <span className="ts-service-icon">
                                                <i className="fas fa-trophy" />
                                            </span>
                                            <div className="ts-service-box-content">
                                                <h3 className="service-box-title">We've Repution for Excellence</h3>
                                            </div>
                                        </div>{/* Service 1 end */}
                                    </div>{/* col end */}
                                    <div className="col-md-6">
                                        <div className="ts-service-box">
                                            <span className="ts-service-icon">
                                                <i className="fas fa-sliders-h" />
                                            </span>
                                            <div className="ts-service-box-content">
                                                <h3 className="service-box-title">We Build Partnerships</h3>
                                            </div>
                                        </div>{/* Service 2 end */}
                                    </div>{/* col end */}
                                </div>{/* Content row 1 end */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="ts-service-box">
                                            <span className="ts-service-icon">
                                                <i className="fas fa-thumbs-up" />
                                            </span>
                                            <div className="ts-service-box-content">
                                                <h3 className="service-box-title">Guided by Commitment</h3>
                                            </div>
                                        </div>{/* Service 1 end */}
                                    </div>{/* col end */}
                                    <div className="col-md-6">
                                        <div className="ts-service-box">
                                            <span className="ts-service-icon">
                                                <i className="fas fa-users" />
                                            </span>
                                            <div className="ts-service-box-content">
                                                <h3 className="service-box-title">A Team of Professionals</h3>
                                            </div>
                                        </div>{/* Service 2 end */}
                                    </div>{/* col end */}
                                </div>{/* Content row 1 end */}
                            </div>{/* Col end */}
                            <div className="col-lg-6 mt-4 mt-lg-0">
                                <h3 className="into-sub-title">Our Values</h3>
                                <p>The core values of Adilite group is commitment to customers, employees and the community. </p>
                                <div className="accordion accordion-group" id="our-values-accordion">
                                    <div className="card">
                                        <div className="card-header p-0 bg-transparent" id="headingOne">
                                            <h2 className="mb-0">
                                                <button className="btn btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Customer Satisfaction
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#our-values-accordion">
                                            <div className="card-body">
                                                We prioritize our customers needs and strive to provide an exceptional buying and service experience. Our goal is to build long-term relationships through trust and satisfaction.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0 bg-transparent" id="headingTwo">
                                            <h2 className="mb-0">
                                                <button className="btn btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    Integrity
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#our-values-accordion">
                                            <div className="card-body">
                                                Honesty and transparency are at the heart of everything we do. We believe in conducting business ethically and treating everyone with respect.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0 bg-transparent" id="headingThree">
                                            <h2 className="mb-0">
                                                <button className="btn btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                    Quality
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#our-values-accordion">
                                            <div className="card-body">
                                                We offer high-quality vehicles and services, ensuring that every customer receives value and reliability in their purchase and maintenance.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0 bg-transparent" id="headingThree">
                                            <h2 className="mb-0">
                                                <button className="btn btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                    Innovation
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#our-values-accordion">
                                            <div className="card-body">
                                                We embrace new technologies and continually seek ways to improve our products and services to better serve our customers.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*/ Accordion end */}
                            </div>{/* Col end */}
                        </div>{/* Row end */}
                    </div>{/* Container end */}
                </section>{/* Feature are end */}
                <section className="subscribe no-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="subscribe-call-to-acton">
                                    <h3>Can We Help?</h3>
                                    <h4>(+91) 9000-123-060</h4>
                                </div>
                            </div>{/* Col end */}
                            {width > 768 ? <div className="col-lg-8">
                                <div className="ts-newsletter row align-items-center">
                                    <div className="col-md-5 newsletter-introtext">
                                        <h4 className="text-white mb-0">Newsletter Sign-up</h4>
                                        <p className="text-white">Latest updates and news</p>
                                    </div>
                                    <div className="col-md-7 newsletter-form">
                                        <form action="#" method="post">
                                            <div className="form-group">
                                                <label htmlFor="newsletter-email" className="content-hidden">Newsletter Email</label>
                                                <input type="email" name="email" id="newsletter-email" className="form-control form-control-lg" placeholder="Your your email and hit enter" autoComplete="off" />
                                            </div>
                                        </form>
                                    </div>
                                </div>{/* Newsletter end */}
                            </div> : null}{/* Col end */}
                        </div>{/* Content row end */}
                    </div>
                    {/*/ Container end */}
                </section>
                {/*/ subscribe end */}
                <section id="ts-service-area" className="ts-service-area pb-0">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-12">
                                <h2 className="section-title">We serve to</h2>
                                <h3 className="section-sub-title">Targeted Sectors</h3>
                            </div>
                        </div>
                        {/*/ Title row end */}
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="ts-service-box d-flex">
                                    <div className="ts-service-box-img">
                                        <img loading="lazy" src="assets/images/icon-image/service-icon2.png" alt="Adilite Group - Manufacturing" />
                                    </div>
                                    <div className="ts-service-box-info">
                                        <h3 className="service-box-title"><a href="#">Manufacturing</a></h3>
                                        <p>For quality control and process optimization, including automotive, aerospace, electronics, and consumer goods manufacturing.
                                        </p>
                                    </div>
                                </div>{/* Service 1 end */}
                                <div className="ts-service-box d-flex">
                                    <div className="ts-service-box-img">
                                        <img loading="lazy" src="assets/images/icon-image/service-icon1.png" alt="Adilite Group - Healthcare and Pharmaceuticals" />
                                    </div>
                                    <div className="ts-service-box-info">
                                        <h3 className="service-box-title"><a href="#">Healthcare and Pharmaceuticals</a></h3>
                                        <p>For diagnostic equipment, laboratory instruments, and quality assurance in drug manufacturing.</p>
                                    </div>
                                </div>{/* Service 2 end */}
                                <div className="ts-service-box d-flex">
                                    <div className="ts-service-box-img">
                                        <img loading="lazy" src="assets/images/icon-image/service-icon3.png" alt="Adilite Group - Energy and Utilities" />
                                    </div>
                                    <div className="ts-service-box-info">
                                        <h3 className="service-box-title"><a href="#">Energy and Utilities</a></h3>
                                        <p>For monitoring and maintaining electrical grids, power plants, and renewable energy installations.                                        </p>
                                    </div>
                                </div>{/* Service 3 end */}
                            </div>{/* Col end */}
                            <div className="col-lg-4 text-center">
                                <img loading="lazy" className="img-fluid" src="assets/images/dealer_logo.jpg" alt="Adilite Group Dealer" />
                            </div>{/* Col end */}
                            <div className="col-lg-4 mt-5 mt-lg-0 mb-4 mb-lg-0">
                                <div className="ts-service-box d-flex">
                                    <div className="ts-service-box-img">
                                        <img loading="lazy" src="assets/images/icon-image/service-icon4.png" alt="Adilite Group - Telecommunications" />
                                    </div>
                                    <div className="ts-service-box-info">
                                        <h3 className="service-box-title"><a href="#">Telecommunications</a></h3>
                                        <p>For testing and maintaining network infrastructure, signal integrity, and data transmission quality.                                        </p>
                                    </div>
                                </div>{/* Service 4 end */}
                                <div className="ts-service-box d-flex">
                                    <div className="ts-service-box-img">
                                        <img loading="lazy" src="assets/images/icon-image/service-icon5.png" alt="Adilite Group - Construction and Civil Engineering" />
                                    </div>
                                    <div className="ts-service-box-info">
                                        <h3 className="service-box-title"><a href="#">Construction and Civil Engineering</a></h3>
                                        <p>For structural integrity assessments, material quality testing, and environmental monitoring.                                        </p>
                                    </div>
                                </div>{/* Service 5 end */}
                                <div className="ts-service-box d-flex">
                                    <div className="ts-service-box-img">
                                        <img loading="lazy" src="assets/images/icon-image/service-icon6.png" alt="Adilite Group - Aerospace and Defense" />
                                    </div>
                                    <div className="ts-service-box-info">
                                        <h3 className="service-box-title"><a href="#">Aerospace and Defense</a></h3>
                                        <p>For testing avionics, communication systems, and ensuring compliance with safety and performance standards.
                                        </p>
                                    </div>
                                </div>{/* Service 6 end */}
                            </div>{/* Col end */}
                        </div>{/* Content row end */}
                    </div>
                    {/*/ Container end */}
                </section>{/* Service end */}
                <section id="project-area" className="project-area solid-bg">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-lg-12">
                                <h2 className="section-title">Adilite Group Dealing With</h2>
                                <h3 className="section-sub-title">Products</h3>
                            </div>
                        </div>
                        {/*/ Title row end */}
                        <div className="row">
                            <div className="col-12">
                                <Container>
                                    <Row className="justify-content-md-center">
                                        {productsList.length !== 0 ? productsList.map((item, index) => index < 6 ? (
                                            <Col>
                                                <Card style={{ width: '18rem', margin: 20, boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>                                                
                                                    <img src={item.ImageFilePath} height="200px" style={{ objectFit: 'contain', margin: 10 }} />
                                                    <Card.Body style={{ textAlign: "center" }}>
                                                        <Card.Title style={{ textAlign: 'center' }}><Link to={`/${item.ProductName.replaceAll(" ","-")}`} title={item.ProductName}>{item.ProductName}</Link></Card.Title>
                                                        <Card.Text style={{ textAlign: 'center' }}>
                                                            {item.ProductDesc}
                                                        </Card.Text>
                                                        <Button variant="outline-primary" size="sm" onClick={() => {
                                                            setSubject(item.ProductName);
                                                            handleEnquireShow();
                                                        }}>Enquire Now</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Button variant="outline-primary" size="sm" onClick={() => {
                                                            setProductName(item.ProductName);
                                                            setResetKey(resetKey + 1);
                                                            setRefreshURL(item.DocFilePath);
                                                            handleShow();
                                                        }}>Preview</Button>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ) : null
                                        ) : null}
                                    </Row>
                                </Container>
                            </div>
                            <div className="col-12">
                                <div className="general-btn text-center">
                                    <a className="btn btn-primary" href="/products">View All Products</a>
                                </div>
                            </div>
                        </div>{/* Content row end */}
                    </div>
                    {/*/ Container end */}
                </section>{/* Project area end */}
                <section className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <h3 className="column-title">Testimonials</h3>
                                <div id="testimonial-slide" className="testimonial-slide">
                                    <div className="item">
                                        <div className="quote-item">
                                            <span className="quote-text">
                                                Question ran over her cheek When she reached the first hills of the Italic Mountains, she had a last
                                                view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the
                                                subline of her own road.
                                            </span>
                                            <div className="quote-item-footer">
                                                <div className="quote-item-info">
                                                    <h3 className="quote-author">Gabriel Denis</h3>
                                                    <span className="quote-subtext">Chairman, OKT</span>
                                                </div>
                                            </div>
                                        </div>{/* Quote item end */}
                                    </div>
                                    {/*/ Item 1 end */}
                                    <div className="item">
                                        <div className="quote-item">
                                            <span className="quote-text">
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor inci done idunt ut
                                                labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitoa tion ullamco laboris
                                                nisi aliquip consequat.
                                            </span>
                                            <div className="quote-item-footer">
                                                <div className="quote-item-info">
                                                    <h3 className="quote-author">Weldon Cash</h3>
                                                    <span className="quote-subtext">CFO, First Choice</span>
                                                </div>
                                            </div>
                                        </div>{/* Quote item end */}
                                    </div>
                                    {/*/ Item 2 end */}
                                    <div className="item">
                                        <div className="quote-item">
                                            <span className="quote-text">
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor inci done idunt ut
                                                labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitoa tion ullamco laboris
                                                nisi ut commodo consequat.
                                            </span>
                                            <div className="quote-item-footer">
                                                <div className="quote-item-info">
                                                    <h3 className="quote-author">Minter Puchan</h3>
                                                    <span className="quote-subtext">Director, AKT</span>
                                                </div>
                                            </div>
                                        </div>{/* Quote item end */}
                                    </div>
                                    {/*/ Item 3 end */}
                                </div>
                                {/*/ Testimonial carousel end*/}
                            </div>{/* Col end */}
                            <div className="col-lg-6 mt-5 mt-lg-0">
                                <h3 className="column-title">Happy Clients</h3>
                                <div className="row all-clients">
                                    <div className="col-sm-4 col-6">
                                        <figure className="clients-logo">
                                            <a href="#!"><img loading="lazy" className="img-fluid" src="assets/images/clients/1.png" alt="Adlite Group clients-logo" /></a>
                                        </figure>
                                    </div>{/* Client 1 end */}
                                    <div className="col-sm-4 col-6">
                                        <figure className="clients-logo">
                                            <a href="#!"><img loading="lazy" className="img-fluid" src="assets/images/clients/2.png" alt="Adlite Group clients-logo" /></a>
                                        </figure>
                                    </div>{/* Client 2 end */}
                                    <div className="col-sm-4 col-6">
                                        <figure className="clients-logo">
                                            <a href="#!"><img loading="lazy" className="img-fluid" src="assets/images/clients/3.png" alt="Adlite Group clients-logo" /></a>
                                        </figure>
                                    </div>{/* Client 3 end */}
                                    <div className="col-sm-4 col-6">
                                        <figure className="clients-logo">
                                            <a href="#!"><img loading="lazy" className="img-fluid" src="assets/images/clients/4.png" alt="Adlite Group clients-logo" /></a>
                                        </figure>
                                    </div>{/* Client 4 end */}
                                    <div className="col-sm-4 col-6">
                                        <figure className="clients-logo">
                                            <a href="#!"><img loading="lazy" className="img-fluid" src="assets/images/clients/5.png" alt="Adlite Group clients-logo" /></a>
                                        </figure>
                                    </div>{/* Client 5 end */}
                                    <div className="col-sm-4 col-6">
                                        <figure className="clients-logo">
                                            <a href="#!"><img loading="lazy" className="img-fluid" src="assets/images/clients/6.png" alt="Adlite Group clients-logo" /></a>
                                        </figure>
                                    </div>{/* Client 6 end */}
                                </div>{/* Clients row end */}
                            </div>{/* Col end */}
                        </div>
                        {/*/ Content row end */}
                    </div>
                    {/*/ Container end */}
                </section>{/* Content end */}
            </div>
            <h5 style={{ color: "#fff", fontSize: 0.1 }}>
                Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research.
                Testing instruments, Measuring instruments, Measurement tools, Testing equipment, Calibration equipment, Specific Instrument Keywords,Multimeters,Oscilloscopes,Pressure gauges,Thermometers, Anemometers, Calipers,pH meters,Data loggers,Spectrum analyzers, Electrical testing instruments, HVAC measuring tools, Laboratory testing equipment, Industrial measurement devices, Environmental testing instruments,Precision measuring instruments,Digital testing tools,Analog measurement tools,Portable testing equipment,Handheld measuring devices,Fluke testing instruments,Extech measuring tools,Tektronix oscilloscopes,Mitutoyo calipers,Keysight measurement devices,High accuracy testing instruments,Wireless measuring devices,Waterproof measuring tools,Multifunction testing equipment, User-friendly measurement tools, How to measure voltage, Best tools for measuring pressure, Accurate temperature measurement devices, Reliable pH testing equipment, Affordable testing instruments, Testing instruments suppliers near me, Measuring tools dealer in hyderabad, andhra pradesh, telangana, bangalore, mumbai, pune, vijaywada, vishakhapatnam, Local calibration equipment services, Nearest industrial testing instruments store, Find pH meters in hyderabad, andhra pradesh, telangana, bangalore, mumbai, pune, vijaywada, vishakhapatnam
                Authorised Secure dealer of APEX 100,Apex 150_R01,Elite 100 & 300 MFM New,Elite 440 New,Elite 500 -Power Monitoring Meter,Liberty 170,Liberty 370,M-cubed_100,premier_300,Prodigy new,ProQ_100,PT1_single function transducer,Saral, saral-300, sprint 350, summator 100, transducerPT1-multi, transducerPT3-multi
            </h5>
            <Modal show={show} onHide={() => setShow(false)} centered dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">{productName}</Modal.Title>
                </Modal.Header>
                <Modal.Body><iframe key={resetKey} src={refreshURL} width="100%" height="400px" /></Modal.Body>
            </Modal>
            <Modal show={enquireShow} onHide={() => setEnquireShow(false)} centered dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">Enquire Now</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Form.Group>
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control value={fullName} onChange={(e) => setFullName(e.target.value)} type="text" placeholder="Enter your full name" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Email</Form.Label>
                            <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter your email" />
                        </Form.Group>
                    </div>
                    <br />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Form.Group>
                            <Form.Label>Mobile No.</Form.Label>
                            <Form.Control value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} type="text" placeholder="Enter your mobile no." />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control value={subject} onChange={(e) => setSubject(e.target.value)} type="text" placeholder="Enter product name" />
                        </Form.Group>
                    </div>
                    <br />
                    <div>
                        <Form.Group>
                            <Form.Label>Message</Form.Label>
                            <Form.Control value={message} onChange={(e) => setMessage(e.target.value)} as="textarea" rows={3} placeholder="Enter your message" />
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleEnquireClose} variant="secondary">Close</Button>
                    <Button variant="primary" onClick={() => {
                        if (fullName !== "" && email !== "" && subject !== "" && message !== "" && mobileNo !== "") {
                            //window.open("mailto:adilitegroup@gmail.com?subject=New%20Enquiry%20From%20Adilite%20Group%20-%20" + fullName + "&body=Hello%20Adilite%20Group%2C%0A%0AI%20hope%20this%20email%20finds%20you%20well.%0A%0A" + message + "%0A%0AI%20am%20writing%20to%20inquire%20about%20this%20" + subject + ".%20Could%20you%20please%20provide%20me%20with%20the%20availability%2C%20pricing%2C%20detailed%20specifications%20or%20any%20additional%20information.%0A%0AThank%20you%20for%20your%20assistance.%20I%20look%20forward%20to%20your%20prompt%20response.%0A%0ABest%20regards%2C%0A%0A" + fullName + "%0A" + email + "%0A" + mobileNo);
                            
                            const phone = "919000123060"; // Country code + phone number (no + or spaces)
                            
                            const whatsappMessage = `*New Contact Inquiry*\n\n*Name:* ${fullName}\n*Email:* ${email}\n*Mobile No:* ${mobileNo}\n*Subject:* ${subject}\n*Message:* ${message}`;

                            const url = `https://wa.me/${phone}?text=${encodeURIComponent(whatsappMessage)}`;

                            window.open(url, "_blank");

                            setEnquireShow(false);
                        }
                        else {
                            setErrorMessage("Enter all valid fields.");
                        }
                    }}>Submit</Button>
                    <div style={{ color: "#FF0000" }}>
                        {errorMessage}
                    </div>
                </Modal.Footer>
            </Modal>
        </Layout>
    );
}

export default Home;
